import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const fetchPrestadoresRestringidos = () => async (dispatch) => {
    
    try {
        const response = await fetchConToken(`PrestadoresRestringidos`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.abmPrestadoresRestringidosTraerSuccess,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los prestadores restringidos.", "Ha ocurrido un error. Intente Nuevamente")

    }

}

export const buscarPrestadoresRestringidos = (text) => (dispatch) =>{
    dispatch({
        type : types.abmBuscarPrestadoresRestringidos,
        payload : text
    });
}

export const nuevoPrestadorRestringido = (datos) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      
      let response = await fetchConToken(`PrestadoresRestringidos`, datos, "POST");
    
      const body = await response.json();
  
      if (response.ok) {
        dispatch(
          startAlerta(
            "Prestador ingresado correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(finishSpinner());
        dispatch(fetchPrestadoresRestringidos());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al ingresar el prestador.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

  export const modificarPrestadorRestringido = (datos) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      
      let response = await fetchConToken(`PrestadoresRestringidos`, datos, "PUT");
    
      const body = await response.json();
  
      if (response.ok) {
        dispatch(
          startAlerta(
            "Prestado modificado correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(finishSpinner());
        dispatch(fetchPrestadoresRestringidos());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar el prestador.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

  export const bajaPrestadorRestringido = (datos) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      
      let response = await fetchConToken(`PrestadoresRestringidos`, datos, "DELETE");
    
      const body = await response.json();
  
      if (response.ok) {
        dispatch(
          startAlerta(
            "baja otorgada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(finishSpinner());
        dispatch(fetchPrestadoresRestringidos());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al dar de baja el prestador.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

  //PRACTICAS

  export const buscarPracticasPrestadoresRestringidos = (text) => (dispatch) =>{
    dispatch({
        type : types.abmBuscarPracticasRestringidosSuccess,
        payload : text
    });
}


export const fetchPracticasPrestadoresRestringidos = (idEfectorFacturacion) => async (dispatch) => {
    
  try {
      const response = await fetchConToken(`PrestadoresRestringidos/Practicas/${idEfectorFacturacion}`);
      const body = await response.json();

      if (response.ok) {
          dispatch({
              type: types.abmPracticasPrestadoresRestringidosSuccess,
              payload: body
          })
      }else {
          throw body;
      }
  } catch (error) {
      handleErrorApi(dispatch, error, "Error al cargar las practicas.", "Ha ocurrido un error. Intente Nuevamente")

  }

}

export const bajaPracticaPrestadorRestringido = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    
    let response = await fetchConToken(`PrestadoresRestringidos/Practicas`, datos, "DELETE");
  
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          "baja otorgada correctamente",
          "success",
          "Comando Exitoso"
        )
      );
      dispatch(finishSpinner());
      dispatch(fetchPracticasPrestadoresRestringidos(datos.idEfectorFacturacion));
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al dar de baja el prestador.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const nuevaPracticaPrestadorRestringido = (idEfectorFacturacion, nivel, idsPracticas) => async (dispatch) => {
  
  try {
    dispatch(startSpinner());
    
    let response = await fetchConToken(`PrestadoresRestringidos/Practicas/${idEfectorFacturacion}/${nivel}`, {idsPracticas}, "PUT");
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          "Practicas guardadas correctamente",
          "success",
          "Comando Exitoso"
        )
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al guardar las practicas del coseguro.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};